// src/components/EarlyAccessBanner.jsx
import { useState } from "react";
import logo from "../assets/e-logo.png";

export default function EarlyAccessBanner() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-sm px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <img
          src={logo}
          alt="EliteHire Pro"
          className="w-5 h-5 object-contain"
        />
        <span>
          EliteHire Pro is in its early stage. Be among the first to post jobs,
          explore opportunities, and help shape the platform.
        </span>
      </div>

      <button
        onClick={() => setVisible(false)}
        className="ml-4 text-white font-bold"
      >
        ✕
      </button>
    </div>
  );
}
